/**
 * Cash balance FE wrapper.
 * BE: GET / PUT /groups/:id/cash-balance
 */

import type { CashBalance, CashBalanceUpsertInput } from '@pta/types';
import { apiCall } from './client';

export function fetchCashBalance(groupId: number): Promise<CashBalance | null> {
  return apiCall(`/groups/${groupId}/cash-balance`);
}

export function upsertCashBalance(
  groupId: number,
  input: CashBalanceUpsertInput,
): Promise<CashBalance> {
  return apiCall(`/groups/${groupId}/cash-balance`, {
    method: 'PUT',
    body: input,
  });
}
